import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	filterData: {},
	productData: {},
	productObj: null,
	activateAssetModal: false,
	adminQuickRequests: null,
	investorSponsoredRequests: null,
	toggleFundLeaseRequestModal: false,
};

export const LeaseSlice = createSlice({
	name: "lease",
	initialState,
	reducers: {
		setFilteredData: (state, action) => {
			state.filterData = action.payload;
		},

		setProductData: (state, action) => {
			state.productData = action.payload;
		},
		saveProduct: (state, action) => {
			state.productObj = action.payload;
		},
		toggleActivateAssetModal: (state, action) => {
			state.activateAssetModal = action.payload;
		},
		saveAdminQuickRequests: (state, action) => {
			state.adminQuickRequests = action.payload;
		},
		saveInvestorSponsoredRequests: (state, action) => {
			state.investorSponsoredRequests = action.payload;
		},
		toggleFundLeaseRequest: (state, action) => {
			state.toggleFundLeaseRequestModal = action.payload;
		},
	},
});

export const {
	setFilteredData,
	setProductData,
	saveProduct,
	toggleActivateAssetModal,
	saveAdminQuickRequests,
	saveInvestorSponsoredRequests,
	toggleFundLeaseRequest,
} = LeaseSlice.actions;

export default LeaseSlice.reducer;
